import BaseModel from './base-model';
import { ServiceResult } from './service-result';
import { formatDate } from '../utils/formatter';

export enum CheckInQuestionKey {
    None = '',
    Allergy = 'allergy',
    Demographic = 'demographic',
    EmergencyContact = 'emergency-contact',
    FamilyHistory = 'family-history',
    Insurance = 'insurance',
    Medication = 'medication',
    PastMedicalHistory = 'past-medical-history',
    Pharmacy = 'pharmacy',
    SocialHistory = 'social-history',
    TelehealthVisit = 'telehealth-visit',
    Thanks = 'thanks',
    VisitReason = 'visit-reason',
    VitalSign = 'vital-sign'
}

export class CheckInQuestion extends BaseModel {
    appointmentId: number;

    questionKey: CheckInQuestionKey = CheckInQuestionKey.None;
    questionDetail: string = '';
    questionDate: string = '';

    answerKey: string = '';
    answerDetail: Undefinable<string>;
    answerDate: string = '';
    answerDetailDate: Undefinable<string>;

    constructor(
        appointmentId: number,
        questionKey: CheckInQuestionKey
    ) {
        super();
        this.appointmentId = appointmentId;
        this.questionKey = questionKey;
        this.questionDate = formatDate({
            destFormat: 'YYYY-MM-DDTHH:mm:ss',
            current: true
        });
    }
}

export type CheckInQuestionResult = ServiceResult<CheckInQuestion>;
